import { Attention as AttentionIcon, Information as InformationIcon, Success as SuccessIcon, Warning as WarningIcon } from 'pcln-icons';
import React from 'react';
import styled from 'styled-components';
import { Box } from '../Box/Box';
import { CloseButton } from '../CloseButton/CloseButton';
import { Flex } from '../Flex/Flex';
import { Text } from '../Text/Text';
import { applyVariations } from '../utils/utils';
const bannerColors = {
  green: {
    backgroundColor: 'secondary.base',
    color: 'text.lightest',
    icon: React.createElement(SuccessIcon, null)
  },
  lightGreen: {
    backgroundColor: 'secondary.light',
    color: 'secondary.dark',
    icon: React.createElement(SuccessIcon, null)
  },
  red: {
    backgroundColor: 'error.base',
    color: 'text.lightest',
    icon: React.createElement(WarningIcon, null)
  },
  lightRed: {
    backgroundColor: 'error.light',
    color: 'error.dark',
    icon: React.createElement(WarningIcon, null)
  },
  orange: {
    backgroundColor: 'alert.base',
    color: 'text.lightest',
    icon: React.createElement(AttentionIcon, null)
  },
  blue: {
    backgroundColor: 'primary.base',
    color: 'text.lightest',
    icon: React.createElement(InformationIcon, null)
  },
  lightBlue: {
    backgroundColor: 'primary.light',
    color: 'primary.dark',
    icon: React.createElement(InformationIcon, null)
  }
};
const StyledBox = /*#__PURE__*/styled(Box).withConfig({
  displayName: "Banner__StyledBox",
  componentId: "sc-1xoq14y-0"
})(["", ""], applyVariations('Banner'));
/**
 * @public
 */
export function Banner(props) {
  const bannerColor = bannerColors[!props.bg && props.color === 'green' ? props.color : props.bg] || {};
  const Icon = props.icon || bannerColor.icon;
  const color = !bannerColor.color ? props.color : bannerColor.color;
  let header = null;
  if (props.header) {
    header = React.isValidElement(props.header) ? props.header : React.createElement(Text, {
      textStyle: 'display2'
    }, props.header);
  }
  return React.createElement(StyledBox, {
    ...props,
    bg: bannerColor.backgroundColor || props.bg,
    color: color
  }, React.createElement(Flex, {
    justifyContent: 'space-between',
    alignItems: 'flex-start'
  }, !!Icon && !!props.showIcon && React.cloneElement(Icon, {
    mr: 2,
    size: 24,
    mt: '-2px'
  }), React.createElement(Box, {
    textAlign: props.textAlign,
    width: 1
  }, header, React.createElement(Text.span, {
    fontSize: 1
  }, props.text), props.children), !!props.onClose && React.createElement(CloseButton, {
    onClick: props.onClose,
    ml: 2,
    size: 24,
    title: 'close',
    mt: '-2px'
  })));
}
Banner.displayName = 'Banner';
Banner.defaultProps = {
  textAlign: 'left',
  showIcon: true,
  color: 'green'
};